import api from '@reportdev-datalake/core-lib/api';
import { usePromise } from '@reportdev-datalake/core-lib/hooks/use-promise';
import LoadingContainer from '@reportdev-datalake/ui-lib/base/loader/LoadingContainer';
import { Redirect } from 'react-router-dom';

export default function () {
  const { isLoading } = usePromise(api.authSignout as any, {});
  // @ts-ignore
  return !isLoading ? <Redirect to={`/admin`} /> : <LoadingContainer />;
}
